export const CREATE_PERFORMANCE_MATRIX = "FUND@CREATE_PERFORMANCE_MATRIX";
export const CREATE_PERFORMANCE_MATRIX_INIT =
  "FUND@CREATE_PERFORMANCE_MATRIX_INIT";
export const CREATE_PERFORMANCE_MATRIX_SUCCESS =
  "FUND@CREATE_PERFORMANCE_MATRIX_SUCCESS";
export const CREATE_PERFORMANCE_MATRIX_FAILED =
  "FUND@CREATE_PERFORMANCE_MATRIX_FAILED";
